import {getUser} from "../services/authService";

const user = getUser();
export const userDetailsUpdate = [
  {
    label: "First Name",
    name: "FirstName",
    disable: false,
    type: "text",
    wdth: 12,
  },
  {
    label: "Last Name",
    name: "LastName",
    disable: false,
    type: "text",
    wdth: 12,
  },
  {
    label: "Email",
    name: "Email",
    disable: false,
    type: "text",
    wdth: 12,
  },
  {
    label: "Mobile No",
    name: "MobileNo",
    disable: false,
    type: "text",
    wdth: 12,
  },
  {
    label: "Date of Birth",
    name: "DateOfBirth",
    disable: false,
    type: "date",
    wdth: 12,
  },
  {
    label: "IsMFA",
    name: "IsMFA",
    type: "checkbox",
  },
  {
    label: "MFADays",
    name: "MFADays",
    disable: false,
    wdth: 12,
    type: "options",
  },
];

export const createUserOnboardingSchema = (roleOptions, supplierOptions, isSupplier) => {
  return [
    ...((user?.isImpexAdmin || user?.isImpexOperation) && isSupplier === "supplier"
      ? [
          {
            label: "Supplier List",
            name: "supplier",
            disable: true,
            wdth: 12,
            type: "autocomplete",
            options: supplierOptions,
            optionLabel: "Name",
          },
        ]
      : []),
    {
      label: "First Name",
      name: "FirstName",
      disable: false,
      wdth: 4,
      type: "text",
    },
    {
      label: "Last Name",
      name: "LastName",
      disable: false,
      wdth: 4,
      type: "text",
    },
    {
      label: "Date Of Onboarding",
      name: "DateOfBirth",
      disable: true,
      wdth: 4,
      type: "date",
    },
    {
      label: "Username",
      name: "LoginId",
      disable: false,
      wdth: 6,
      type: "text",
    },
    {
      label: "Phone Number",
      name: "MobileNo",
      disable: false,
      wdth: 6,
      type: "number",
    },
    {
      label: "Email Address",
      name: "Email",
      disable: true,
      wdth: 6,
      type: "email",
    },
    {
      label: "Role",
      name: "role",
      disable: true,
      wdth: 6,
      type: "autocomplete",
      options: roleOptions,
      optionLabel: "RoleName",
    },
    {
      label: "Address",
      name: "HomeTownAddress",
      disable: true,
      wdth: 6,
      type: "text",
    }
  ];
};

export const editRoleForm = [
  {
    label: "Role",
    name: "role",
    disable: false,
    wdth: 12,
    type: "autocomplete",
    default: {
      key: "RoleId",
      label: "RoleName",
    },
  },
];

export const resetPasswordForm =  [
  {
    label: "Login ID",
    name: "LoginId",
    disable: true,
    type: "text",
    wdth: 12,
  },
  {
    label: "Email",
    name: "Email",
    disable: true,
    type: "text",
    wdth: 12,
  },
  {
    label: "Password",
    name: "Password",
    disable: false,
    type: "Password",
    wdth: 12,
  },
]

export const forgotPasswordForm =  [
  {
    label: "Code",
    name: "PassCode",
    disable: false,
    type: "text",
  },
  {
    label: "New Password",
    name: "newPassword",
    disable: false,
    type: "password",
  },
  {
    label: "Confirm Password",
    name: "confirmPassword",
    disable: false,
    type: "Password",
  },
]